module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/jobs/jobs-show/jobs-show.component.scss
// module id = ./src/app/views/setting/jobs/jobs-show/jobs-show.component.scss
// module chunks = main